export async function ensurePersistentStorage(): Promise<boolean> {
    if (navigator.storage && navigator.storage.persist) {
      const isPersisted = await navigator.storage.persisted();
  
      if (isPersisted) {
        console.log("✅ IndexedDB is already persistent.");
        return true;
      }
  
      const granted = await navigator.storage.persist();
      if (granted) {
        console.log("✅ Persistent storage granted.");
      } else {
        console.warn("⚠️ Persistent storage not granted. Data may be cleared.");
      }
  
      return granted;
    } else {
      console.warn("⚠️ Persistent storage API not supported in this browser.");
      return false;
    }
  }
  
  export async function logStorageEstimate() {
    if (navigator.storage && navigator.storage.estimate) {
      const { quota, usage } = await navigator.storage.estimate();
      console.log(
        `Storage usage: ${(usage! / 1024 / 1024).toFixed(2)} MB of ${(quota! / 1024 / 1024).toFixed(2)} MB`
      );
    }
  }
  